import { render, staticRenderFns } from "./combinationCard.vue?vue&type=template&id=577ccaca&scoped=true&"
import script from "./combinationCard.vue?vue&type=script&lang=js&"
export * from "./combinationCard.vue?vue&type=script&lang=js&"
import style0 from "./combinationCard.vue?vue&type=style&index=0&id=577ccaca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577ccaca",
  null
  
)

export default component.exports